import type { WorksheetTitleItem } from '@packages/clients';

import type { WorksheetTitleEntity } from '../entities';

/**
 * Map a {@link WorksheetTitleItem} DTO to a {@link WorksheetTitleEntity}.
 *
 * @param dto - the worksheet title DTO from the titles endpoint
 * @returns the domain entity
 * @example
 * ```ts
 * const entity = toWorksheetTitleEntity({ displayName: 'NVH', worksheetDescription: 'Noise', worksheetId: 'ws-1' });
 * ```
 */
export function toWorksheetTitleEntity(dto: WorksheetTitleItem): WorksheetTitleEntity {
    return {
        displayName: dto.displayName,
        worksheetDescription: dto.worksheetDescription,
        worksheetId: dto.worksheetId,
    };
}
